"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromPackagesConfigEntry = fromPackagesConfigEntry;
exports.parse = parse;
exports.getMinimumTargetFramework = getMinimumTargetFramework;
const parseXML = require("xml2js");
const debugModule = require("debug");
const depsParser = require("dotnet-deps-parser");
const framework_1 = require("../framework");
const errors_1 = require("../../errors");
const debug = debugModule('snyk');
function fromPackagesConfigEntry(manifest) {
    debug('Extracting by packages.config entry:' +
        ' name = ' +
        manifest.$.id +
        ' version = ' +
        manifest.$.version);
    return {
        dependencies: {},
        name: manifest.$.id,
        version: manifest.$.version,
    };
}
function parse(fileContent) {
    const installedPackages = [];
    debug('Trying to parse packages.config manifest');
    parseXML.parseString(fileContent, (err, result) => {
        if (err) {
            throw err;
        }
        if (!('packages' in result)) {
            throw new errors_1.InvalidManifestError(`Could not find a <packages> tag in your packages.config file. Please read this guide \x1b[4mhttps://learn.microsoft.com/en-us/nuget/reference/packages-config#schema\x1b[0m.`);
        }
        const packages = result.packages.package || [];
        packages.forEach(function scanPackagesConfigNode(node) {
            const installedDependency = fromPackagesConfigEntry(node);
            installedPackages.push(installedDependency);
        });
    });
    return installedPackages;
}
async function getMinimumTargetFramework(fileContent) {
    const extractedFrameworks = await depsParser.extractTargetFrameworksFromProjectConfig(fileContent);
    if (extractedFrameworks && extractedFrameworks.length > 0) {
        const minimumFramework = extractedFrameworks.reduce((prev, curr) => prev < curr ? prev : curr);
        return (0, framework_1.toReadableFramework)(minimumFramework);
    }
    return undefined;
}
//# sourceMappingURL=packages-config-parser.js.map